import { capabilityGuard } from './core/guards/capability.guard';
import { Routes } from '@angular/router';
import { authenticationGuard } from './core/guards/authentication.guard';
import { onboardingGuard } from './core/guards/onboarding.guard';
import { superAdminGuard } from './core/guards/super-admin.guard';
import { billingStatusGuard } from './core/guards/billing-status.guard';


export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./features/login/pages/login/login.page').then(m => m.LoginPage) },
  {
    path: 'forgot-password',
    loadComponent: () => import('./features/forgot-password/forgot-password.component').then(m => m.ForgotPasswordComponent)
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./features/reset-password/reset-password.component').then(m => m.ResetPasswordComponent)
  },
  {
    path: 'accept-invitation',
    loadComponent: () => import('./features/auth/accept-invitation/accept-invitation.component').then(m => m.AcceptInvitationComponent)
  },
  // Onboarding (fuera del layout, requiere autenticación pero no onboarding completado)
  {
    path: 'onboarding',
    canActivate: [authenticationGuard],
    loadChildren: () => import('./features/onboarding/onboarding.routes').then(m => m.onboardingRoutes)
  },
  {
    path: '',
    loadComponent: () => import('./layout/app-layout/app-layout.component').then(m => m.AppLayoutComponent),
    canActivate: [authenticationGuard, onboardingGuard, billingStatusGuard], // protege TODAS las rutas hijas
    canActivateChild: [capabilityGuard],
    children: [
      { path: '', redirectTo: 'home', pathMatch: 'full' },
      // ===== NUEVAS RUTAS FEATURE-BASED =====
      { path: 'menu-management', canActivate: [superAdminGuard], canDeactivate: [(component: {canLeave:()=>boolean|Promise<boolean>})=>component.canLeave()], loadComponent: () => import('./features/navigation-profiles/navigation-profiles.page').then(m=>m.NavigationProfilesPage) },
      {
        path: 'home',
        loadComponent: () => import('./features/home-dashboard/home-dashboard.page').then(m => m.HomeDashboardPage)
      },
      {
        path: 'my-account',
        loadComponent: () => import('./features/my-account/my-account.page').then(m => m.MyAccountPage)
      },
      {
        path: 'token-costs',
        loadComponent: () => import('./features/my-account/token-costs.page').then(m => m.TokenCostsPage)
      },
      {
        path: 'select-plan',
        loadComponent: () => import('./features/company-billing/pages/select-plan/select-plan.page').then(m => m.SelectPlanPage)
      },
      {
        path: 'users',
        loadChildren: () => import('./features/users/users.routes').then(m => m.USERS_ROUTES)
      },
      {
        path: 'roles',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/roles/roles.routes').then(m => m.ROLES_ROUTES)
      },
      {
        path: 'devices',
        loadChildren: () => import('./features/devices/devices.routes').then(m => m.DEVICES_ROUTES)
      },
      {
        path: 'promotions',
        loadChildren: () => import('./features/promotions/promotions.routes').then(m => m.PROMOTIONS_ROUTES)
      },
      {
        path: 'customers',
        loadChildren: () => import('./features/customers/customers.routes').then(m => m.CUSTOMERS_ROUTES)
      },
      {
        path: 'companies',
        loadChildren: () => import('./features/companies/companies.routes').then(m => m.COMPANIES_ROUTES)
      },
      {
        path: 'media',
        loadChildren: () => import('./features/media/media.routes').then(m => m.MEDIA_ROUTES)
      },
      {
        path: 'advices',
        loadChildren: () => import('./features/announcements/announcements.routes').then(m => m.ANNOUNCEMENTS_ROUTES)
      },
      {
        path: 'coupons',
        loadChildren: () => import('./features/coupons/coupons.routes').then(m => m.COUPONS_ROUTES)
      },
      {
        path: 'analytics',
        loadComponent: () => import('./features/analytics/analytics-hub.page').then(m => m.AnalyticsHubPage)
      },
      {
        path: 'analytics/global',
        canActivate: [superAdminGuard],
        loadComponent: () => import('./features/analytics/global-dashboard/analytics-global-dashboard.component').then(m => m.AnalyticsGlobalDashboardComponent)
      },
      {
        path: 'super-admin',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/super-admin/super-admin.routes').then(m => m.superAdminRoutes)
      },
      {
        path: 'admin/stripe-prices',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/super-admin/stripe-config/stripe-config.module').then(m => m.StripeConfigModule)
      },
      // ✅ NUEVAS FEATURES:
      {
        path: 'promotion-redemptions',
        loadChildren: () => import('./features/promotion-redemptions/promotion-redemptions.routes').then(m => m.PROMOTION_REDEMPTIONS_ROUTES)
      },
      {
        path: 'clients',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/clients/clients.routes').then(m => m.CLIENTS_ROUTES)
      },
      {
        path: 'company-billing',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/company-billing/company-billing.routes').then(m => m.COMPANY_BILLING_ROUTES)
      },
      {
        path: 'invoices',
        loadChildren: () => import('./features/invoices/invoices.routes').then(m => m.routes)
      },

      // TODO: Crear features restantes:
      // - user-actions
      // - billing-events
      // - data-exports
      {
        path: 'integrations',data:{integrationsHome:true},
        loadComponent:()=>import('./features/api-keys/pages/api-keys-list.page').then(m=>m.ApiKeysListPage)
      },
      {
        path: 'api-keys',
        loadChildren: () => import('./features/api-keys/api-keys.routes').then(m => m.API_KEYS_ROUTES)
      },
      {
        path: 'impersonation-audits',
        canActivate: [superAdminGuard],
        loadComponent: () => import('./features/impersonation-audits/impersonation-audits.page').then(m => m.ImpersonationAuditsPage)
      },
      {
        path: 'plans',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/plans/plans.routes').then(m => m.PLANS_ROUTES)
      },
      {
        path: 'billing-periods',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/billing-periods/billing-periods.routes').then(m => m.BILLING_PERIODS_ROUTES)
      },
      {
        path: 'device-types',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/device-types/device-types.routes').then(m => m.DEVICE_TYPES_ROUTES)
      },
      {
        path: 'media-types',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/media-types/media-types.routes').then(m => m.MEDIA_TYPES_ROUTES)
      },
      {
        path: 'app-versions',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/app-versions/app-versions.routes').then(m => m.APP_VERSIONS_ROUTES)
      },
      {
        path: 'app-entities',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/app-entities/app-entities.routes').then(m => m.APP_ENTITIES_ROUTES)
      },
      {
        path: 'entity-attributes',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/entity-attributes/entity-attributes.routes').then(m => m.ENTITY_ATTRIBUTES_ROUTES)
      },
      // ===== REMARKETING =====
      {
        path: 'audience-segments',
        loadChildren: () => import('./pages/audience-segments/audience-segments.routes').then(m => m.AUDIENCE_SEGMENTS_ROUTES)
      },
      {
        path: 'marketing-campaigns',
        loadChildren: () => import('./pages/marketing-campaigns/marketing-campaigns.routes').then(m => m.MARKETING_CAMPAIGNS_ROUTES)
      },
      {
        path: 'notification-templates',
        loadChildren: () => import('./pages/notification-templates/notification-templates.routes').then(m => m.NOTIFICATION_TEMPLATES_ROUTES)
      },
      // ===== GEOFENCING =====
      {
        path: 'geofencing/zones',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/geofencing/geofence-zones/geofence-zones.routes').then(m => m.GEOFENCE_ZONES_ROUTES)
      },
      {
        path: 'geofencing/rules',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/geofencing/geofence-rules/geofence-rules.routes').then(m => m.GEOFENCE_RULES_ROUTES)
      },
      {
        path: 'geofencing/events',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/geofencing/geofence-events/geofence-events.routes').then(m => m.GEOFENCE_EVENTS_ROUTES)
      },
      // ===== FRAUD DETECTION =====
      {
        path: 'fraud-detection/rules',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/fraud-detection/fraud-rules/fraud-rules.routes').then(m => m.FRAUD_RULES_ROUTES)
      },
      {
        path: 'fraud-detection/alerts',
        canActivate: [superAdminGuard],
        loadChildren: () => import('./features/fraud-detection/fraud-alerts/fraud-alerts.routes').then(m => m.FRAUD_ALERTS_ROUTES)
      },
      // ===== ADVANCED ANALYTICS =====
      {
        path: 'analytics/advanced',
        redirectTo: '/analytics?tab=advanced',
        pathMatch: 'full'
      }
    ],
  },
  // Ruta de retorno de Stripe Embedded Checkout
  {
    path: 'payment/return',
    canActivate: [authenticationGuard],
    loadComponent: () => import('./features/payment/pages/payment-return/payment-return.page').then(m => m.PaymentReturnPage)
  },
  { path: '**', redirectTo: '' },
];
